<template>
    <div class='page-detail-bjsw bjsw-detail-ylbx'>
        <div class="detail-top">
            <a href="javascript:;" class="go-back crad-back" @click="e=>this.$router.push('/details/bjswcard/')"></a>            
            <a href="javascript:;" class="apply-button" @click="showPopup('myPopup')"></a>
        </div>
        <div class="detail-content">
            <div class="content-box1">
                <div class="cell-box-01">
                    <img src="@/assets/images/bjswc/icon_car.png" alt="">
                    <p>医疗保险</p>
                </div>                
            </div>
            <div class="content-box2">
                <div class="p-content">
                    <div class="title-box">
                        <img src="@/assets/images/bjswc/icon_bar.png" alt="">
                        <p>医疗保障</p>
                    </div>
                    <img id="table" src="@/assets/images/bjswc/bx_table.png" alt="">
                   
                </div>
                <div class="p-content p-content2">
                     <div class="title-box">
                        <img src="@/assets/images/bjswc/icon_bar.png" alt="">
                        <p>理赔流程</p>
                    </div>
                    <p class="pContent">
                        1、客户通过“中国人寿寿险APP”及个人理赔链接（“中国人寿股份上海市分公司服务号”公众号—活动中心—个人理赔申请）线上申请理赔；线上理赔金额不得超过人民币10000元。</br>
                        2、理赔金额超过10000元的客户可以通过我行通知保险专员申请线下理赔。</br>
                        3、注意事项：首次投保最高年龄为60周岁。</br>
                        4、白金商务卡持卡人如对保险服务有任何问题，请拨打保险公司全国客服电话：95519进行咨询。
                    </p>
                </div>              
            </div>
        </div>

        <cube-popup type="my-popup" ref="myPopup">
            <div class="popup-content">
                <img src="@/assets/images/bjswc/yy_popup.png" alt="">
                <p>烦请致电24小时客服热线</br>962999进行预约办理。</p>
                <a href="javascript:;" class="closebtn" @click="hidePopup('myPopup')"></a>
            </div>
        </cube-popup>        
    </div>
</template>




<script>
export default {
    data () {
        return {

        };
    },
    methods:{
        showPopup(refId) {
            const component = this.$refs[refId]
            component.show()                
        },
        hidePopup(refId){
            const component = this.$refs[refId]
            component.hide()                
        }
    }
}

</script>


<style lang="scss" scoped>
</style>